import moment from 'moment-timezone';
import * as d3 from 'd3-format';

moment.locale('en', {
  calendar : {
    lastDay : '[Yesterday at] LT',
    sameDay : '[Today at] LT',
    nextDay : '[Tomorrow at] LT',
    lastWeek : '[last] dddd [at] LT',
    nextWeek : 'dddd [at] LT',
    sameWeek : '[Last] dddd [at] LT',
    sameElse : 'LL'
  }
});

export const formatDate = ({d, timezone}) => {
  timezone = timezone || 'America/Chicago';
  if(!d){
    return 'Invalid Date';
  }
  return moment(d).tz(timezone).calendar();  
};

export const formatPercentage = (v) => {
  return `${Math.round(v * 100)}%`;
}

export const formatDecimal = (v, numPlaces=2) => {
  return d3.format(`.${numPlaces}f`)(v);
}

export const formatKwh = kwh => {
  let prefixes = ['k', 'M', 'G', 'T', 'P'];
  let i = 0;
  while(Math.abs(kwh) >= 1000){
    kwh /= 1000;
    i += 1;
    if(i >= prefixes.length-1){
      break;
    }
  }
  return [kwh, `${prefixes[i]}Wh`];
}

export const formatWattage = v => {
  let unit = 'W';
  return `${d3.format(".3s")(v)}${unit}`;
}